import axios from 'axios';
import { supabase } from '../config/supabase';

interface StepData {
  id: string;
  step: number;
  instructions: string;
  thumbnail: string;
  video: File | null;
  mediaType: 'thumbnail' | 'video';
}

export const saveRecipeSteps = async (recipeId: string, steps: StepData[]) => {
  try {
    // First, delete all existing steps for this recipe
    const { error: deleteError } = await supabase
      .from('RecipeSteps')
      .delete()
      .eq('RecipeID', recipeId);

    if (deleteError) throw deleteError;

    // Then insert the new steps
    if (steps.length > 0) {
      const { data, error } = await supabase
        .from('RecipeSteps')
        .insert(
          steps.map(step => ({
            RecipeID: recipeId,
            Step: step.step,
            Instructions: step.instructions,
            Thumbnail: step.thumbnail
          }))
        );

      if (error) throw error;
      return data;
    }

    return [];
  } catch (error) {
    console.error('Error saving recipe steps:', error);
    throw error;
  }
}; 